export default "__VITE_ASSET__BmCSJ9cB__"